import React from "react";
import { motion } from "framer-motion";
import withStyles from "@mui/styles/withStyles";

export const styles = () => ({
  root: {
    position: "relative",
    width: "min-content",
  },
  bottomSection: {
    position: "absolute",
    bottom: "-6px",
  },
  container: {
    borderRadius: "50%",
    overflow: "hidden",
  },
  inverted: {
    transform: "scaleX(-1)",
  },
});

const TheMinimalist = ({
  stroke = "#333",
  backgroundFill = "#F9CA54",
  frontFill = "#39728E",
  height = "81",
  width = "81",
  classes,
  flipped = false,
  isAnimated = true,
}) => {
  return (
    <div data-testid="minimalist-mascot-svg" className={`${classes.root} ${flipped && classes.inverted}`}>
      <motion.svg
        width={width}
        height={height}
        viewBox="0 0 91 91"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        animate={
          isAnimated
            ? {
                scale: [1, 1.01, 1],
              }
            : {}
        }
        transition={
          isAnimated
            ? {
                duration: 2,
                ease: "easeInOut",
                repeat: Infinity,
                repeatDelay: 5,
              }
            : {}
        }
      >
        <g filter="url(#filter0_d_2921_861)">
          <path
            data-testid="the-minimalist-mascot-bg"
            d="M48 88.0007C70.0914 88.0007 88 70.092 88 48.0005C88 25.909 70.0914 8.00037 48 8.00037C25.9086 8.00037 8 25.909 8 48.0005C8 70.092 25.9086 88.0007 48 88.0007Z"
            fill={backgroundFill}
          />
        </g>
        <mask id="mask0_2921_861" maskUnits="userSpaceOnUse" x="24" y="28" width="46" height="41">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M68.2596 36.5614H68.259L68.2557 35.217C68.2531 33.8766 68.0329 32.5917 67.0851 31.6439C66.1372 30.6961 64.8524 30.1624 63.5119 30.1598H62.493C62.493 30.1598 62.493 30.1598 62.493 30.1598H30.7855C29.445 30.1624 28.1602 30.6961 27.2124 31.6439C26.2645 32.5918 25.7309 33.8766 25.7283 35.2171V54.8257C25.7309 56.1661 26.2645 57.451 27.2124 58.3988C28.1602 59.3467 29.445 59.8803 30.7855 59.8829H56.8596C56.9684 59.8831 57.0759 59.9069 57.1746 59.9529C57.2732 59.9988 57.3607 60.0657 57.4308 60.1488L62.4635 66.2156V60.6068C62.4635 60.4109 62.5413 60.223 62.6798 60.0845C62.8183 59.946 63.0062 59.8682 63.2021 59.8682C64.5434 59.8669 65.8295 59.3338 66.7784 58.3858C67.7273 57.4378 68.2617 56.1522 68.2643 54.8109L68.2596 36.5614ZM69.7362 35.0942V35.0841C69.7349 33.3514 69.3563 31.823 68.1311 30.5978C66.9059 29.3727 65.2446 28.6838 63.5119 28.6825L62.1676 28.6825V28.6825H30.7855C29.0528 28.6838 27.3915 29.3727 26.1663 30.5979C24.9412 31.8231 24.2523 33.4844 24.251 35.2171V54.8109C24.2523 56.5436 24.9412 58.2049 26.1663 59.4301C27.3915 60.6553 29.0528 61.3441 30.7855 61.3454H56.51L62.6309 68.7319C62.7001 68.815 62.7866 68.8818 62.8845 68.9278C62.9823 68.9737 63.0891 68.9976 63.1972 68.9978C63.3931 68.9978 63.581 68.92 63.7195 68.7815C63.858 68.643 63.9358 68.4551 63.9358 68.2592V61.2913C65.5307 61.1078 67.0027 60.3449 68.0721 59.1475C69.1415 57.9501 69.7339 56.4016 69.7366 54.7961V35.2171C69.7391 35.1761 69.7391 35.135 69.7366 35.094C69.7365 35.094 69.7363 35.0941 69.7362 35.0942Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_2921_861)">
          <rect
            data-testid="the-minimalist-mascot-msg-first-half"
            width="47.3128"
            height="52.1977"
            transform="matrix(0.984808 0.173649 -0.173648 0.984808 23.958 17.3566)"
            fill={frontFill}
          />
          <rect
            data-testid="the-minimalist-mascot-msg-second-half"
            width="41.364"
            height="56.9532"
            transform="matrix(0.984808 -0.173649 0.173648 0.984808 37.2129 36.1064)"
            fill={frontFill}
          />
        </g>
        <motion.circle
          animate={
            isAnimated
              ? {
                  scale: [0.5, 1, 0.5],
                  opacity: [0.5, 1, 0.5, 0],
                }
              : { opacity: 0 }
          }
          transition={
            isAnimated
              ? {
                  duration: 0.7,
                  ease: "easeInOut",
                  // times: [0, 0.2, 0.5, 0.8, 1],
                  repeat: Infinity,
                  repeatDelay: 5,
                }
              : { opacity: 0 }
          }
          cx="47"
          cy="45"
          r="4"
          fill={frontFill}
        />
        <motion.circle
          animate={
            isAnimated
              ? {
                  scale: [1, 0.5, 0.5],
                  opacity: [1, 0.5, 0.5, 0],
                }
              : { opacity: 0 }
          }
          transition={
            isAnimated
              ? {
                  duration: 0.7,
                  ease: "easeInOut",
                  // times: [0, 0.2, 0.5, 0.8, 1],
                  repeat: Infinity,
                  repeatDelay: 5,
                }
              : { opacity: 0 }
          }
          cx="35"
          cy="45"
          r="4"
          fill={frontFill}
        />
        <motion.circle
          animate={
            isAnimated
              ? {
                  scale: [0.5, 0.5, 1],
                  opacity: [0.5, 0.5, 1],
                  x: [1, 1, 1, 10],
                  y: [1, 1, 1, -12],
                }
              : { x: 10, y: -12, scale: 1, opacity: 1 }
          }
          exit={isAnimated ? { opacity: 0 } : { opacity: 1 }}
          transition={
            isAnimated
              ? {
                  duration: 0.7,
                  ease: "easeInOut",
                  times: [0, 0.2, 0.5, 0.8, 1],
                  repeat: Infinity,
                  repeatDelay: 5,
                }
              : {}
          }
          cx="59"
          cy="45"
          r="4"
          fill={frontFill}
          stroke={backgroundFill}
          stroke-width="2"
        />
        <defs>
          <filter
            id="filter0_d_2921_861"
            x="0.367337"
            y="0.367703"
            width="95.2653"
            height="95.2656"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset />
            <feGaussianBlur stdDeviation="3.81633" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2921_861" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2921_861" result="shape" />
          </filter>
        </defs>
      </motion.svg>
    </div>
  );
};

export default withStyles(styles)(TheMinimalist);
